import { h, Component } from 'preact';
import Border from '../border/border';
import Footer from '../footer/footer';
import Content from '../content/content';
import styles from './trade.css';

export default class Security extends Component {
  render() {
    return (<div>
      <div className={styles.container}>
        <Content>
          <div className={styles.text}>
          <div className="flex">
            <a href="/"><img className={styles.logo} src="/assets/logo-red.png" alt="Trouble Brewing" /></a>
            <h1 className={styles.title}>Security Policy Statement</h1>
          </div>
          <p>Trouble Brewing is committed to protecting the company's employees, properties, information, reputation and customer's assets from potential threats in the supply chain. This policy is guided by the company’s basic core values, code of conduct, business ethics and supply chain security standards, and it dictates the way we operate throughout the supply chain. This Security Policy applies to individuals/entities that are provided access to information resources, including approved third party consultants, contractors and vendors.</p>
          <p>All security activities must adhere to the general principles laid down below:</p>
          <ul>
            <li>All employees and contractors must always be aware of and take responsibility for the security aspects of the company’s business activities;</li>
            <li>Threats analysis and risk evaluations should be conducted on a regular basis;</li>
            <li>Security procedures and guidelines should be seamlessly integrated with business activities;</li>
            <li>Security measures and procedures must be subject to regular inspections, validations and verifications as noted by the relevant Security Policy so as to maintain high security standards for all operations.</li>
            <li>The level of professionalism, knowledge and integrity of staff involved in security matters must be tightly controlled and vetted.</li>
            <li>Appropriate training plans, customer screening, recruitment, contracting and termination procedures must be established and implemented and documented.</li>
            <li>All incidents, including security breaches and irregularities must be reported and recorded. Corrective action should be taken and followed up through regular verifications to improve the overall security standard.</li>
          </ul>
          <p>With regard to data/digital security specifically, the principle of role-based access control is applied at Trouble Brewing; only the employees with the authority and requirement to access information will do so. To this end:</p>
          <ul>
            <li>Our standard operating procedures include requiring that employees who will have access to sensitive information are trained information security, as well as held up to a high ethical and compliance standard. </li>
            <li>All Employee end-user machines have industry standard anti-virus software installed, which is updated and monitored regularly.</li>
            <li>All data and activity will be stored in cloud-based software to ensure the veracity and secure storage/access of all data </li>
            <li>Notwithstanding these protections, Trouble Brewing recognizes that all IT systems remain vulnerable to attack; therefore, monitoring is essential to ensure the reliability and security of all data</li>
          </ul>
          <p>This policy has been approved by the Management Directors at Trouble Brewing. It will be reviewed, and if necessary revised, annually to keep up to date and will be released on our company website. </p>
          </div>
          </Content>
          <Border color="black" />
        </div>
      <Footer />
    </div>);
  }
}



// WEBPACK FOOTER //
// ./components/trade/security.jsx